import axiosInstance from "./api_helper";

const API_URL = '/api/commission/plans';

export const commissionPlanService = {

    list: async ({query}) => {
        const params = {};
        if (query) params.query = query;
        const response = await axiosInstance.get(API_URL, { params });
        return response;
    },
    create: async (dto) => {
        const response = await axiosInstance.post(API_URL, dto);
        return response.data;
    },
    update: async (dto) => {
        const response = await axiosInstance.put(`${API_URL}/${dto.id}`, dto);
        return response.data;
    },
    delete: async ({ id }) => {
        await axiosInstance.delete(`${API_URL}/${id}`);
    },
};